import FormValueGetter from "./applied_form/form_value_getter"

export default class AnswerFactory {
  constructor(questionCard) {
    this.questionId = questionCard.getAttribute('data-question-id')
    this.questionKind =  questionCard.getAttribute('data-question-kind')
    this.value = new FormValueGetter(questionCard).getValue()
    this.answerId = questionCard.getAttribute('data-answer-id')
  }

  build() {
    if(this.hasComplementaryField()) { return this.valueWithComplementary() }

    if (this.answerId != null) {
      return {
        question_id: this.questionId,
        value: this.value,
        answer_id: this.answerId
      }
    } else {
      return {
        question_id: this.questionId,
        value: this.value
      }
    }
  }

  hasComplementaryField() {
    const fieldsWithComplementary = [
      'check_with_others_option',
      'boolean_with_complementary_options_on_false',
      'radio_with_others_option',
      'boolean_with_complementary_options_on_true',
      'boolean_with_check_options_on_fase',
      'boolean_with_check_options_on_true',
      'boolean_with_boolean_on_true',
      'boolean_with_radio_on_true'
    ]
    if (fieldsWithComplementary.includes(this.questionKind)) { return true }

    return false
  }

  valueWithComplementary() {
    if (this.answerId != null) {
      return {
        question_id: this.questionId,
        value: this.value.value.toString(),
        complementary_value: this.value.complementaryValue,
        answer_id: this.answerId
      }
    } else {
      return {
        question_id: this.questionId,
        value: this.value.value?.toString(),
        complementary_value: this.value.complementaryValue
      }
    }
  }
}
